
import * as signalR from '@microsoft/signalr';

const hubUrl = process.env.REACT_APP_SIGNAL_URI; // Replace with your SignalR hub URL

export const createSignalRConnection = () => {

    const fullUrl = `${hubUrl}?locationShareLinkId=${localStorage.getItem("shareId")}`;
    
  const connection = new signalR.HubConnectionBuilder()
    .withUrl(fullUrl)
    .withAutomaticReconnect()
    .configureLogging(signalR.LogLevel.Information)
    .build();


  connection.onreconnecting((error) => {
    console.log('Connection lost due to error. Reconnecting.', error);
  });

  connection.onreconnected((connectionId) => {
    console.log('Connection reestablished. Connected with connectionId', connectionId);
  });

  connection.onclose((error) => {
    console.log('Connection closed due to error. Try refreshing this page to restart the connection', error);
  });

  return connection;
};

export const startConnection = async (connection) => {
  if (connection.state === signalR.HubConnectionState.Disconnected) {
    connection.start()
      .then(() => {
        console.log('SignalR Connected. Id : ' + connection.connectionId);
      })
      .catch((error) => {
        console.error('SignalR Connection Error: ', error);
        setTimeout(() => startConnection(connection), 5000);
      });
  }
}